import { SharedAngular } from '@Client/@types/sharedAngular';
import IProcedureOverview from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureOverview';
import { Guid } from '@Shared.Angular/@types/guid';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import angular, { IQService } from 'angular';
import { IStateService } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

class RunnerLibraryTabsComponentController {
  businessName: string;
  canCreateFlowModels: boolean;
  helpUri: string;
  flowModels: any[] = [];
  procedures: IProcedureOverview[] = [];
  showBulkImportWhenEmpty: boolean;
  enableFormThemes: boolean;
  allowWorkflow: boolean;
  allowProcessMap: boolean;
  enableProcedures: boolean;
  enableTagging: boolean;
  usedTagIds: Guid[] = [];
  stateMappings = STATE_MAPPINGS;
  subscriberId: string;
  onTagFilterChange: (args: { selectedTagIds: Guid[] }) => void;
  selectedTagIds: Guid[] = [];

  static $inject = [
    '$state',
    'sessionService',
    'brandingService',
    'permissionsService',
    'flowModelApiService',
    'dialogService',
    '$q',
    'APP_CONFIG'
  ];

  constructor(
    private $state: IStateService,
    private sessionService: SharedAngular.SessionService,
    private brandingService: SharedAngular.BrandingService,
    private permissionsService: SharedAngular.PermissionsService,
    private flowModelApiService: SharedAngular.FlowModelApiService,
    private dialogService: SharedAngular.DialogService,
    private $q: IQService,
    private APP_CONFIG: SharedAngular.APP_CONFIG
  ) {
    this.businessName = this.sessionService.getBusinessName();
    this.helpUri = this.brandingService.getBrandedHelpUri(
      'https://help.flowingly.net/coming-soon/how-do-i-create-manage-processes-for-my-business'
    );
    this.canCreateFlowModels = this.permissionsService.currentUserHasPermission(
      FlowinglyPermissions.FLOWMODEL_CREATE
    );
    this.showBulkImportWhenEmpty =
      this.permissionsService.currentUserHasPermission(
        FlowinglyPermissions.FLOWMODEL_BULKIMPORT
      );
    this.allowWorkflow = this.APP_CONFIG.allowWorkflow;
    this.enableFormThemes =
      this.allowWorkflow &&
      this.permissionsService.currentUserHasAnyOfPermissions([
        FlowinglyPermissions.FORM_THEME_CREATE,
        FlowinglyPermissions.FORM_THEME_PUBLISH,
        FlowinglyPermissions.FORM_THEME_DELETE
      ]);
    this.allowProcessMap = this.APP_CONFIG.allowProcessMap;
    this.enableTagging = this.APP_CONFIG.enableTagging;
    this.enableProcedures = this.APP_CONFIG.enableProcedures;
    this.subscriberId = 'flowingly.runner.library';
  }

  fetchFlowModels = () => {
    const deferred = this.$q.defer();
    this.flowModelApiService
      .getFlowModels()
      .then((result) => {
        this.flowModels = result;
        const currentTab = window.location.pathname
          .split('/')
          .filter(Boolean)
          .pop();
        this.switchTab(currentTab);
        deferred.resolve(result);
      })
      .catch((error) => {
        console.error('Error fetching flow models and categories:', error);
        deferred.reject(error);
      });
    return deferred.promise;
  };

  openBulkImporter = () => {
    this.dialogService
      .showDialog({
        template:
          'Client/runner.import/flowmodels/runner.import.flowmodels.dialog.tmpl.html',
        controller: 'importFlowModelsDialogController',
        appendClassName: 'ngdialog-normal'
      })
      .then(this.onListUpdated);
  };

  switchTab = (tabName) => {
    switch (tabName.toLowerCase()) {
      case 'workflows':
        this.$state.go(STATE_MAPPINGS.libraryworkflows);
        break;
      case 'processmaps':
        this.$state.go(STATE_MAPPINGS.libraryprocessmaps);
        break;
      case 'drafts':
        this.$state.go(STATE_MAPPINGS.librarydrafts);
        break;
      case 'procedures':
        this.$state.go(STATE_MAPPINGS.libraryprocedures);
        break;
      case 'form-themes':
        this.$state.go(STATE_MAPPINGS.libraryFormThemes);
        break;
      default:
        this.$state.go(STATE_MAPPINGS.libraryworkflows);
    }
  };

  onListUpdated(needResizeGrid) {
    this.fetchFlowModels().then(function () {
      if (needResizeGrid) {
        this.gridNeedResize = true;
      }
    });
  }

  handleTagFilterChange = (selectedTags: Guid[]) => {
    this.selectedTagIds = selectedTags;
    this.onTagFilterChange({ selectedTagIds: selectedTags });
  };

  get isProceduresTab(): boolean {
    return this.$state.includes(STATE_MAPPINGS.libraryprocedures);
  }
}

export class RunnerLibraryTabsComponent implements angular.IComponentOptions {
  public templateUrl =
    'Client/runner.library/runner.library.tabs.component.tmpl.html';

  public bindings = {
    flowModels: '<',
    usedTagIds: '<',
    onTagFilterChange: '&'
  };

  public controller = [
    '$state',
    'sessionService',
    'brandingService',
    'permissionsService',
    'flowModelApiService',
    'dialogService',
    '$q',
    'APP_CONFIG',
    RunnerLibraryTabsComponentController
  ];
}

angular
  .module('flowingly.runner.library')
  .component('runnerLibraryTabs', new RunnerLibraryTabsComponent());
